<template>
  <div v-cloak class="Resource">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">方舟资讯</div>
        <div class="texts">新鲜资讯、随时播报、一网打尽</div>
      </div>
    </div>

    <!-- 中间内容 -->
    <div class="Bread">
      <Bread :list="breadList" />
    </div>

    <div id="w-1200px" class="r-container">
      <div class="con-left">
        <div class="flex f-between ma-t-10 ma-b-10">
            <div class="flex">
              <div @click="isHot" class="pointer ma-r-40 fon-14">
                <div class="c-8a flex f-center" v-show="sortType != 2">
                  <img src="../img/redu.png" class="img_22 ma-r-10" />按热度排序
                </div>
                <div class="c-234775 flex f-center" v-show="sortType == 2">
                  <img
                    src="../img/redu2.png"
                    class="img_22 ma-r-10"
                  />按热度排序
                </div>
              </div>
              <div @click="isDate" class="pointer">
                <div class="c-8a flex f-center  fon-14" v-show="sortType != 1">
                  <img src="../img/riqi.png" class="img_22 ma-r-10" />按日期排序
                </div>
                <div class="c-234775 flex f-center fon-14" v-show="sortType == 1">
                  <img
                    src="../img/riqi2.png"
                    class="img_22 ma-r-10"
                  />按日期排序
                </div>
              </div>
            </div>
          </div>
        <el-tabs @tab-click="handleClick" v-model="activeName">
          
          <el-tab-pane
            v-for="kind in kinds"
            :key="kind.Id"
            :label="kind.Name"
            :name="kind.Id"
          ></el-tab-pane>
          <div ref="cp">
            <!-- 方舟资讯 -->
            <div class="three_box ma-center">
              <div class="">
                <div
                  class="
                    boxs-r
                    ma-t-30
                    height302
                    flex
                    f-between
                    pa-b-20
                    b-b-1-e3
                  "
                  v-for="(item, index) in dataList.List"
                  :key="index"
                >
                  <div v-if="item.Image" class="ma-r-20">
                    <img
                      :src="item.Image"
                      class="img_263 c-p"
                      @click="toDetail(item.Id)"
                    />
                  </div>

                  <div
                    class="
                      flex flex-direction flex-grow-1
                      pa-t-10 pa-r-20
                      f-between
                    "
                  >
                    <div>
                      <div
                        class="t-omit-2 fon-16 bold c-p"
                        @click="toDetail(item.Id)"
                      >
                        {{ item.Name }}
                      </div>
                      <div
                        class="ma-t-20 fon-15 c-8a t-omit-4 c-p t-justify"
                        @click="toDetail(item.Id)"
                      >
                        {{ item.Summary }}
                      </div>
                    </div>
                    <div class="c-8a flex f-between fon-14 ma-t-10">
                      <div>{{ item.ReleaseTime }}</div>
                      <div class="flex f-center p-r">
                        <div>
                          <i class="iconfont icon-yanjing"></i>
                          {{ item.ViewCount }}
                        </div>
                        <div>
                          <i
                            class="iconfont ma-l-20"
                            :class="
                              item.IsCollection ? 'icon-star2' : 'icon-xingxing'
                            "
                            @click="toCollection(item.Id, index)"
                          ></i>
                        </div>
                        <div>
                          <i
                            class="iconfont icon-fenxiang11 ma-l-20"
                            @mouseenter="shareMouseenter(item.Id)"
                            @mouseleave="shareMouseleave(item.Id)"
                          ></i>
                        </div>
                        <div
                          class="box-share"
                          :id="'box-share-' + item.Id"
                          @mouseenter="shareMouseenter(item.Id)"
                          @mouseleave="shareMouseleave(item.Id)"
                        >
                          <div class="flex f-center">
                            <div class="t-center">
                              <img
                                v-if="qrUrls[index]"
                                :src="qrUrls[index]"
                                alt=""
                                srcset=""
                                width="120"
                                class="img-qrCode"
                              />
                              <div class="t-center">微信扫码分享</div>
                            </div>
                            <div class="p-r">
                              <img
                                src="../img/weibo.png"
                                alt=""
                                srcset=""
                                width="60"
                                class="c-p ma-l-10"
                                 title="点击分享"
                                @click="weibo(item)"
                              />
                            </div>
                            <div class="p-r ma-l-20">
                              <img
                                src="../img/qzone.png"
                                alt=""
                                srcset=""
                                width="60"
                                class="c-p"
                                title="点击分享"
                                @click="QQShare(item)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="fy">
            <el-pagination
              @current-change="handleCurrentChange"
              :hide-on-single-page="true"
              :current-page.sync="pageIndex"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="totals"
            ></el-pagination>
          </div>
        </el-tabs>
      </div>
      <div class="con-right-wrap">
        <div class="con-right">
          <div class="flex f-center ma-t-10 bold">
            <i class="chunk ma-r-10"></i>最热榜TOP10
          </div>
          <div
            v-for="(item, index) in hotNewsList"
            :key="index"
            class="li-news fon-14"
            @click="toDetail(item.Id)"
          >
            <span
              class="chunk-top"
              :class="{
                'chunk-top1': index == 0,
                'chunk-top2': index == 1,
                'chunk-top3': index == 2,
                'chunk-top-other': index > 2,
              }"
              >{{ index + 1 }}</span
            >{{ item.Name }}
          </div>
          <div class="img-qrcode">
            <div class="frame-img">
              <img src="../img/qrcode.png" alt="" srcset="" />
            </div>
            <div class="t-center fon-14">欢迎关注数智方舟微信公众号</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.t-justify{
  text-align: justify
}
.p-r {
  position: relative;
}
.Resource {
  .el-tabs__nav-wrap{
    width: 100%;
  }
  .box-share {
    // position: absolute;
    top: -160px;
    width: 290px;
    right: 0;
    // border: 1px solid red;
    background: #fff;
    padding: 10px;
    box-shadow: 0 1px 4px 0 #bdbdbd;
    border-radius: 2px;
    display: none;
  }
  .img-qrcode {
     .frame-img{
      margin: 20px auto;
      border: 2px solid #e4e7ed;
      height: 200px;
      width: 200px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 99%;
      }
    }
  }
  .con-right-wrap {
    width: 30%;
  }
  .con-right {
    width: 100%;
    background: #fff;
    padding: 20px;
    height: auto;
  }
  .con-left {
    width: 65%;
    background: #fff;
    padding: 20px;
  }
  .h-auto {
    height: auto;
  }
  .chunk {
    display: inline-block;
    width: 5px;
    height: 23px;
    background: #234775;
    border-radius: 3px;
  }
  .li-news {
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 20px;
    .chunk-top {
      width: 20px;
      height: 20px;
      border-radius: 3px;
      display: inline-block;
      text-align: center;
      color: #fff;
      line-height: 19px;
      margin-right: 6px;
    }
    .chunk-top1 {
      background: #ff0000;
    }
    .chunk-top2 {
      background: #ff2b2b;
    }
    .chunk-top3 {
      background: #ff5e5e;
    }
    .chunk-top-other {
      background: #7d7d7d;
    }
  }
}

.el-tabs--top {
  width: 100%;
}
.c-8a {
  color: #8a8a8a;
}
.c-009294 {
  color: #009294;
}
.img_22 {
  width: 15px;
  height: 15px;
}
.ma-lr-15 {
  margin: 0 18px;
}
.c-41 {
  color: #414141;
}
.rz {
  width: 50%;
  margin: 15px auto;
  border-radius: 3px;
  text-align: center;
  padding: 10px 10px;
  background-color: #e6e6e6;
  color: #000;
  font-weight: 500;
}
.containerss {
  width: 1200px;

  margin: 0 auto;
  background: #ffffff;
  padding: 0px 14px 25px 14px;
  box-sizing: border-box;

  .fy {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .product-main {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .product-list {
      width: 370px;
      height: 121px;
      margin-right: 20px;
      margin-bottom: 38px;
      display: flex;
      justify-content: flex-start;
      .p-image {
        width: 35%;
        height: 121px;
        margin-right: 9px;
        .p-imgs {
          width: 121px;
          height: 121px;
          border-radius: 10px;
        }
      }
      .p-title {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 8px;
      }
      .p-detail {
        // width:100%;
        font-size: 14px;
        height: 38px;
        line-height: 19px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .p-right {
        width: 65%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .download {
        width: 90px;
        height: 30px;
        background: rgba(15, 117, 189, 1);
        border-radius: 20px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
}
.Resource {
  min-width: 1200px;
  background: rgba(245, 247, 250, 1);
}
.Resource .swiper {
  width: 100%;
  height: 314px;
  background-image: url(../img/资讯.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  .toptexts {
    width: 736px;
    position: absolute;
    top: 28%;
    margin: 0 auto;
    left: 50%;
    margin-left: -368px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;

    color: #fff;
    opacity: 0.75;
    text-align: center;
    .texts {
      line-height: 30px;
      letter-spacing: 3px;
      font-size: 16px;
    }
    .imgtitle {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}
.fy {
  margin-top: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Resource .r-container {
  width: 1200px;
  // height: 600px;
  // min-height: 500px;
  box-sizing: border-box;
  // padding: 30px 40px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  min-height: 1150px;

  display: flex;
  justify-content: space-between;
}
.Resource .r-container {
  margin-bottom: 30px;
  .el-tabs__header {
    display: flex;
    justify-content: left;
    margin-top: 15px;
  }
  .el-tabs__content {
    // min-width: 1080px;
    margin: 0 auto;
  }
  .el-tabs__item {
    padding: 0 60px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }
  .el-tabs__active-bar {
    height: 4px;
    font-weight: bold;
    background: #234775;
  }
  .is-active {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #234775;
  }
  .el-tabs__content {
    // margin-top: 45px;
  }
}
.Resource .student {
  width: 1100px;
  height: 106px;
  margin-bottom: 32px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  .img-left {
    width: 20%;
    height: 106px;

    .img-lefts {
      width: 187px;
      height: 106px;
    }
  }
  .text-right {
    width: 80%;
    .title {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #333333;
      margin-top: 3px;
      margin-bottom: 5px;
    }
    .text-detail {
      padding-right: 100px;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 18px;
      font-family: MicrosoftYaHei;
      color: rgba(102, 102, 102, 1);
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .icons {
      // width: 100%;
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .deletes {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          i {
            font-size: 18px;
          }
        }
      }

      .icons-left {
        width: 100%;
        padding-right: 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icons-left-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
      .delete-right {
        width: 40%;
        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
    }
  }
}
.three_box {
  width: 100%;
  height: auto;
  margin-top: 12px;
  .boxs-r {
    background: #ffffff;
    // box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
    // border-radius: 10px;
    .img_263 {
      width: 230px;
      height: 149px;
      object-fit: cover;
    }
    .img_30 {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      top: 205px;
      left: 10px;
    }
  }
}
.ma-t-60 {
  margin-top: 60px !important;
}
.ma-t-10 {
  margin-top: 10px !important;
}
.ma-t-12 {
  margin-top: 12px !important;
}
.height40 {
  height: 36px;
}
.c-234775 {
  color: #234775;
}
</style>
<script>
import { newsCategory, newsList, NewsHotArticle, Collection } from "../api.js";
import Bread from "../components/Bread.vue";

//二维码生成
import QRCode from "qrcode";
// studycollect
export default {
  name: "Resource",
  components: {
    Bread,
  },
  data() {
    return {
      activeName: "",
      pageIndex: 1,
      pageSize: 16,
      totals: 0, //一个分类下的总条数
      dataList: [],
      kinds: [],
      breadList: [{ name: "方舟资讯", path: "/Resource" }],
      sortType: 0,
      hotNewsList: [],
      qrUrls: [],
    };
  },

  created() {
    // let token = localStorage.getItem('AccessToken');

    newsCategory().then((res) => {
      this.kinds = res.data.Data;
      this.activeName = res.data.Data[0].Id;
      this.getList();
    });
    this.NewsHotArticle();
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);
    next();
  },

  // 其他页面进来时更新初始数据
  activated() {},

  methods: {
    //微博分享
    weibo(item) {
      var query = {
        title:item.Name,
        url:'http://www.fz-ai.net/Study-detail?id='+item.Id,
      };
      if(item.Image){
        query.pic=item.Image
      }
      let url ="http://service.weibo.com/share/share.php?" + this.buildUrlQuery(query);
       window.open(url);
    },
    //QQ空间分享
    QQShare(item){
      var query = {
        title:item.Name,
        summary:item.Summary,
        url:'http://www.fz-ai.net/Study-detail?id='+item.Id,
      };
      if(item.Image){
        query.pics=item.Image
      }
      let url ="http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?" + this.buildUrlQuery(query);
       window.open(url);
    },
    //拼接url
    buildUrlQuery(query) {
      var queryItems = [];
      for (var k in query) {
        queryItems.push(k + "=" + encodeURIComponent(query[k] || ""));
      }
      return queryItems.join("&");
    },
    //获取二维码图片url
    loadDataQrUrl() {
      var _this = this;
      for (let index = 0; index < this.dataList.List.length; index++) {
        QRCode.toDataURL(
          "http://m.fz-ai.net/pages/resource/detail?Id=" +
            this.dataList.List[index].Id,
          {},
          function (err, url) {
            if (err) throw err;
            _this.qrUrls[index] = url;
          }
        );
      }
    },
    //鼠标悬浮分享按钮
    shareMouseenter(id) {
      let dom = document.getElementById("box-share-" + id);
      dom.style.display = "block";
    },
    //鼠标移开分享按钮
    shareMouseleave(id) {
      let dom = document.getElementById("box-share-" + id);
      dom.style.display = "none";
    },
    login() {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$confirm("您还未登录请先登录?", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/Login");
          })
          .catch(() => {
            return false;
          });
      } else {
        return true;
      }
    },
    toCollection(Id, index) {
      if (this.login()) {
        let token = localStorage.getItem("AccessToken") || "";
        let data = {
          Id: Id,
          Token: token,
        };
        Collection(data).then((res) => {
          console.log(res);
          if (res.data.Code == 0) {
            this.dataList.List[index].IsCollection =
              !this.dataList.List[index].IsCollection;
            if (this.dataList.List[index].IsCollection) {
              this.$message.success("收藏成功");
            } else {
              this.$message.success("已取消收藏");
            }
          }
        });
      }
    },
    //获取热门资讯
    NewsHotArticle() {
      NewsHotArticle().then((res) => {
        this.hotNewsList = res.data.Data;
      });
    },
    isDate() {
      if (this.sortType == 1) {
        this.sortType = 0;
      } else if (this.sortType == 2) {
        this.sortType = 1;
      } else {
        this.sortType = 1;
      }

      this.getList();
    },
    isHot() {
      if (this.sortType == 2) {
        this.sortType = 0;
      } else if (this.sortType == 1) {
        this.sortType = 2;
      } else {
        this.sortType = 2;
      }
      this.getList();
    },
    getList() {
      let data = {
        categoryId: this.activeName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sortType: this.sortType,
      };
      newsList(data).then((res) => {
        if (res.data.Code == 0) {
          this.dataList = res.data.Data;

          this.totals = res.data.Data.TotalCount;
          this.loadDataQrUrl();
        }
      });
    },

    toDetail(id = 1) {
      this.$router.push({
        path: "/Study-detail",
        query: { id: id },
      });
    },

    //点击切换种类
    handleClick(tab) {
      console.log(tab);

      this.pageIndex = 1;
      this.sortType = 0;
      this.getList();
    },

    upload(e) {
      window.open(e, "_blank");
    },

    // 设置保存页码
    save() {
      let kinds = this.kinds;
      this.saves = kinds.map((item) => {
        return { id: item.Id, page: 1 };
      });
    },

    // 详情
    collect(id) {
      this.$router.push({
        path: "/Study-detail",
        query: { paths: "/Resource", name: "学习资源", id: id },
      });
    },

    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.getList();
    },
  },
};
</script>
